import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBathrobe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3523 3.33333C17.936 2.5 17.02 2 16.0207 2H8.02673C7.02748 2 6.1115 2.5 5.61187 3.41667L2.03123 13.1667C1.94796 13.4167 2.03123 13.75 2.28104 13.9167L5.86169 15.9167V22H18.0192V15.9167L21.6831 13.9167C21.933 13.75 22.0995 13.4167 21.933 13.1667L18.3523 3.33333ZM15.0215 3.25L11.5241 8.75L9.10925 3.25H15.0215ZM3.44683 13.0833L6.86094 3.91667C7.02748 3.58333 7.44383 3.33333 7.86019 3.25L11.8572 12.75H7.11075V10.0833C7.11075 9.75 6.86094 9.5 6.44458 9.5C6.02823 9.5 5.86169 9.66667 5.86169 10.0833V14.5L3.44683 13.0833ZM7.11075 14H12.107V20.75H7.11075V14V14ZM16.7702 20.75H13.3561V14H16.7702V20.75ZM18.0192 14.5V10.0833C18.0192 9.75 17.7694 9.5 17.3531 9.5C16.9367 9.5 16.6869 9.75 16.6869 10.0833V12.75H13.1063L12.0237 10.1667L16.3538 3.41667C16.6869 3.5 16.9367 3.75 17.1033 3.91667L20.5174 13.1667L18.0192 14.5Z",
		fill: "black"
	})
});
export default SvgBathrobe;
